import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'relation'
})
export class RelationPipe implements PipeTransform {

  transform(value: any, selection: string, propName: string): any {
    if (value.length === 0 || selection === 'Any') {
      return value;
    }
    const resultArray = [];
    for (const item of value) {
      if (item[propName] === selection) {
        resultArray.push(item);
      }
    }
    return resultArray;

  }

}
